import React from "react";
import { Link } from "react-router-dom";
const UsHome = () => {
  const cardData = [
    { imgsrc: "images/why1.png", title: "Expert Members" },
    { imgsrc: "images/why2.png", title: "100% Satisfaction" },
    { imgsrc: "images/w3.jpg", title: "24/7 Support" },
    { imgsrc: "images/w4.png", title: "Dedicated To Work" },
  ];

  return (
    <div className="flex flex-col items-center justify-start max-w-[1224px] mt-[20px] p-4 md:mt-5 mx-auto md:px-0 w-full">
      <div className="flex flex-col gap-9 items-center justify-start w-full">
        <div className="md:w-[60%] sm:w-[100%] m-auto">
                    <h2 className='my-4 font-bold text-center text-3xl sm:text-4xl text-black max-w-[300px] m-auto border-b-2 border-[#E12126] uppercase'>Why Choose Us</h2>
               <p className="text-gray-700 text-[12px] lg:text-[16px] text-center">
                <>
                We seek to recruit a proficient team comprising editors, graphic designers, developers, programmers, animators, and content writers, all of whom are seasoned professionals. Our team excels in conceptual thinking, employing an open minded approach to effectively communicate your brand’s narrative!{" "}
                </>
              </p>
              </div>
        {/* Grid layout for cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 w-full ">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="shadow-lg rounded-lg overflow-hidden bg-white border border-gray-200"
            >
              <img
                src={card.imgsrc}
                alt={card.title}
                className="w-full h-auto object-cover"
              />
              <p className="text-center py-4 text-lg font-bold text-gray-900">
                {card.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UsHome;
